import axios from 'axios';
import React, { Component, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useSelector, useDispatch } from 'react-redux';
import Network from './Requests';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { globalConfig } from '../configuration/config';
import { setLink, linkActive, setList, setPhone } from '../store/reducers/linkSlice';
import { setOpenPublicForm, setCloseActionPanel } from '../store/reducers/saveGuids';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useTheme } from '@mui/material/styles';
import { openPublicLinkForm as openPublicLinkFormAction } from '../store/reducers/publicLinkSlice';
import { useTranslation } from "react-i18next";

const Links = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [count, setCount] = React.useState();
  const [page, setPage] = React.useState(1);
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const { t } = useTranslation();
  let size = 50;

  const channel = t("linksPage.channels", { returnObjects: true });
  const types = t("linksPage.types", { returnObjects: true });

  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.project.companyId);
  const linkList = useSelector((state) => state?.link?.list);
  const openPublic = useSelector((state) => state.guids.openPublicForm);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetch = async (pageNum) => {
    setIsLoading(true);
    try {
      const send = await new Network().GetPublicLinks(companyId, pageNum, size);

      for (let i = 0; i < send?.data.length; i++) {
        const element = send?.data[i];
        let start = new Date(element.activeFrom);
        let end = new Date(element.activeTo);
        let diff = Date.parse(end) - Date.parse(start);
        element.seconds = diff / 1000;
      }

      if (pageNum === 1) {
        dispatch(setList(send?.data)); // первая страница — замена
      } else {
        dispatch(setList([...linkList, ...send?.data])); // остальные — добавление
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetch(page);
    }
  }, [companyId, page]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (!isLoading && scrollHeight - scrollTop <= clientHeight + 5) {
      setPage((prev) => prev + 1);
    }
  };

  const openEditEmpty = () => {
    dispatch(setPhone(true));
    dispatch(setOpenPublicForm(true));
  };

  const openEdit = (link) => {
    dispatch(setOpenPublicForm(true));
    dispatch(setLink(link));
  };

  const copyPublicLink = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(function () {
        console.log('Текст скопирован в буфер обмена:', link);
      })
      .catch(function (error) {
        console.error('Ошибка при копировании текста:', error);
      });
  };

  const timerProps = {
    isPlaying: true,
    size: 65,
    strokeWidth: 3,
  };

  const timeLeft = (timeEnd, sec) => {
    let start = new Date();
    let end = new Date(timeEnd);
    let diff = Date.parse(end) / 1000 - Date.parse(start) / 1000;
    return diff;
  };

  const minuteSeconds = 60;
  const hourSeconds = 3600;
  const daySeconds = 86400;

  const rendTime = (remainingTime) => {
    let diff = (Date.parse(new Date(remainingTime)) - new Date()) / 1000;
    let day = Math.floor(diff / 86400);
    let hours = Math.floor(diff / 3600);
    let minutes = Math.floor((diff % 3600) / 60);
    let seconds = Math.floor(diff % 60);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    if (diff > daySeconds) {
      return `${day}д.`;
    }

    if (diff > hourSeconds) {
      return `${hours}ч.`;
    }
    if (diff > minuteSeconds) {
      return `${minutes}м.`;
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        disableScrollLock={true}>
        <div
          // style={modalStyle}
          style={{
            position: 'absolute',
            padding: '20px 24px',
            width: 700,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: theme.palette.background.paper, // Используем theme
            borderRadius: '8px',
            overflowY: 'scroll',
          }}>
          <div className="links">
            <div className="links-wrapper">
              <div className="infoList--title">{ t("menu.publicLinks") }</div>
              <div className="add-links">
                <button onClick={() => dispatch(openPublicLinkFormAction())}>{t("linksPage.add") }</button>
              </div>
            </div>
            <div className="links-wrapper">
              <TableContainer component={Paper} onScroll={handleScroll} sx={{ maxHeight: '70vh' }} >
                <Table aria-label="simple table" sx={{ minWidth: 650, maxWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>{ t("linksPage.table.icon") }</TableCell>
                      <TableCell>{ t("linksPage.table.name") }</TableCell>
                      <TableCell>{ t("linksPage.table.channel") }</TableCell>
                      <TableCell>{ t("linksPage.table.type") }</TableCell>
                      <TableCell>{ t("linksPage.table.code") }</TableCell>
                      <TableCell>{ t("linksPage.table.time") }</TableCell>
                      <TableCell></TableCell>
                      {/* <TableCell>Перейти</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {linkList?.map((row) => (
                      <TableRow
                        key={row.guid}
                        onClick={() => dispatch(openPublicLinkFormAction(row))}>
                        <TableCell>
                          <div
                            className="back-img"
                            style={{
                              backgroundImage: `url(${row?.iconPath && row?.iconPath})`,
                            }}></div>
                        </TableCell>
                        <TableCell>{row?.calculationName}</TableCell>
                        <TableCell>{channel[row?.salesChanel]}</TableCell>
                        <TableCell>{types[row?.varietyType]}</TableCell>
                        <TableCell
                          onClick={(event) => {
                            event.stopPropagation();
                            copyPublicLink(row?.publicLinkUrl);
                          }}>
                          {row?.publicLinkUrl}
                        </TableCell>
                        {/* <TableCell>
                          <a
                            href={
                              globalConfig.config.common.chat +
                              '/app?pr=' +
                              row?.guidProject +
                              '&variant=' +
                              row?.guidCalculation
                            }
                            target="_blank"
                            className="link-pr">
                            Проект
                          </a>
                        </TableCell> */}
                        {Date.parse(new Date(row?.activeTo)) == 0 && (
                          <TableCell align="center">
                            <div>∞</div>
                          </TableCell>
                        )}
                        {(Date.parse(new Date(row?.activeFrom)) - Date.parse(new Date()) > 0 ||
                          Date.parse(new Date(row?.activeTo)) - Date.parse(new Date()) < 0) &&
                          Date.parse(new Date(row?.activeTo)) != 0 && (
                            <TableCell align="center">
                              <div className="timer-late"></div>
                            </TableCell>
                          )}
                        {Date.parse(new Date()) - Date.parse(new Date(row?.activeFrom)) > 0 &&
                          Date.parse(new Date()) - Date.parse(new Date(row?.activeTo)) < 0 && (
                            <TableCell align="center">
                              <div className="cicle-pad">
                                <CountdownCircleTimer
                                  {...timerProps}
                                  colors="#3390ec"
                                  duration={
                                    (Date.parse(new Date(row?.activeTo)) -
                                      Date.parse(new Date(row?.activeFrom))) /
                                    1000
                                  }
                                  size="45"
                                  trailColor="#A5A5A5"
                                  initialRemainingTime={
                                    (Date.parse(new Date(row?.activeTo)) - Date.parse(new Date())) /
                                    1000
                                  }>
                                  {({ elapsedTime, color }) => (
                                    <span className="time-links" style={{ color }}>
                                      {rendTime(row?.activeTo)}
                                    </span>
                                  )}
                                </CountdownCircleTimer>
                              </div>
                              {/* <div className="timer-late"></div> */}
                            </TableCell>
                          )}

                        <TableCell align="center">{row?.visitsCount}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </Modal>
      <div className="bm-item menu-item" onClick={handleOpen}>
        { t("menu.publicLinks") }
      </div>
    </div>
  );
};

export default Links;
